import { YellowTextCpt } from "./YellowTextCpt";

export const YellowUnidoodleCpt = () => {
  return (
    <>
      Uni<YellowTextCpt>Doodle</YellowTextCpt>
    </>
  );
};
